import { useState } from 'react';
import { useMapInstance } from 'shared/map-exports';
import { useMapEvent } from 'features/mapping/hooks/useMapEvent';

export const useMapBearing = (): number | undefined => {
  const map = useMapInstance();
  const [bearing, setBearing] = useState<number | undefined>(() =>
    map?.getBearing(),
  );

  useMapEvent(
    'rotate',
    (event) => {
      setBearing(event.target.getBearing());
    },
    map,
    true,
  );

  return bearing;
};
